import i18n from '@/i18n/locale';
export default [
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
      theme: 'dark',
      header: { userVisible: false },
      sidebar: { visible: false },
      useLogin: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "home" */
        '@/views/HomeView.vue'
      ),
  },
  {
    path: '/account',
    name: 'Account',
    meta: {
      title: i18n.t('Entrega_order__qLWr' /** 账户管理 */),
      sideMenu: {
        weight: 40,
        label: i18n.t('Entrega_order__qLWr' /** 账户管理 */),
        icon: 'icon-filled_setting',
        type: 4,
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "account" */
        '@/views/Account.vue'
      ),
  },
  {
    path: '/add-account',
    name: 'AddAccount',
    meta: {
      title: i18n.t('Entrega_Website__xEde' /** 详细信息填写 */),
      theme: 'dark',
      sidebar: { visible: false },
      footer: { visible: false },
    },
    component: () =>
      import(
        /* webpackChunkName: "account" */
        '@/views/AddAccount.vue'
      ),
  },
];
